export enum CompetenciesCardType {
  COMMON,
  MANAGEMENT
}
